import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageTabs = ({ currentLang, onLangChange, languages = ['nl', 'fr', 'de', 'en'] }) => {
  const { t } = useTranslation();

  const languageNames = {
    nl: t('admin.languageTabs.dutch'),
    fr: t('admin.languageTabs.french'),
    de: t('admin.languageTabs.german'),
    en: t('admin.languageTabs.english')
  };

  const languageFlags = {
    nl: '🇳🇱',
    fr: '🇫🇷',
    de: '🇩🇪',
    en: '🇬🇧'
  };

  return (
    <div className="flex gap-1 border-b border-gray-200 mb-4">
      {languages.map((lang) => (
        <button
          key={lang}
          onClick={() => onLangChange(lang)}
          className={`flex items-center gap-2 px-4 py-2 font-medium transition-colors ${
            currentLang === lang
              ? 'text-primary-600 border-b-2 border-primary-600'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          }`}
          type="button"
        >
          <span className="text-lg">{languageFlags[lang]}</span>
          <span className="hidden sm:inline">{languageNames[lang]}</span>
          <span className="sm:hidden">{lang.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageTabs;
